import axios from "axios";
import { navigateTo } from "utils/location";
import { capturePendingRedirect } from "utils/pendingRedirect";

const TIMED_OUT = "/#/login/timed-out";

const paths = {
  401: TIMED_OUT,
  405: TIMED_OUT,
  901: "/#/login/permissions-updated",
  902: "/#/login/logged-out",
};

const errorHandler = (error) => {
  const statusCode = error?.status;
  const data = error?.data;

  const isSystemError = statusCode === 500;
  const isForbidden = statusCode === 403;

  const redirectPath = data?.isSso ? "/saml/login" : paths[statusCode];

  if (redirectPath && !isForbidden) {
    capturePendingRedirect();
    navigateTo(redirectPath);
    throw new axios.Cancel("redirecting...");
  }
  if (
    isSystemError &&
    data?.error === "Error getting user first and last name"
  ) {
    navigateTo("/#/exception/saml-error");
  }
};

export default errorHandler;
